<template>
<div class="praydetail">
    <div class="container pray_container" v-if="pray">
        <img class="logo-mobile" alt="OrePorMim" src="../assets/img/logo_v3-negative.png" /><br />
        <div class="owner_avatar_holder">
            <img class="owner_avatar" :src="pray.avatarURL" />            
        </div>
        <div class="pray_card" v-if="pray">
            <div class="pray_prays">
                <img class="icon" src="../assets/img/hands_icon.png" /> {{ pray.prays }} <span v-if="pray.prays == 1">oração</span><span v-else>orações</span>
            </div>
            <div class="arrow">
                <img class="iarrow" src="../assets/img/avatar_arrow.png" />
            </div>
            <div class="pray_message">
                <div v-if="pray.achieved" class="achieved">
                    Pedido realizado!
                </div>
                <p v-html="parsedMessage(pray.message)"></p>
                <div class="pray_owner"> - {{ pray.username }}</div>
            </div>
            <div class="pray_prayers" v-if="prayers.length">
                <div class="prayer" v-for="prayer in prayers" :key="prayer.uid">
                    <img class="prayer_avatar" :src="prayer.avatarURL" />
                    {{ prayer.username }}
                    <img class="icon_prayers" src="../assets/img/hands_icon.png" />
                </div>
            </div>
        </div>
    </div>
    <div class="watermark">
        <img class="logo" alt="OrePorMim" src="../assets/img/logo_v3-negative.png" /><br />
        <a href="https://play.google.com/store/apps/details?id=net.xupisco.prayforme"><img class="googleplay" alt="Download na GooglePlay" src="../assets/img/google-play-badge.png" /></a>
    </div>
</div>
</template>

<script>
// pray_id: -LKnHEy2yWNoVO1nsIJM
import {db} from '../firebase';

export default {
    props: ['pray_id'],
    data() {
        return {
            pray: null,
            prayers: []
        }
    },
    firestore() {
        return {
            pray: db.doc('fake_prays/' + this.pray_id),
            prayers: db.collection('fake_prays/' + this.pray_id + '/prayers'),
        }
    },
    methods: {
        parsedMessage: (str) => {
            str = str.replace('\n', '<br /><br />');
            return str.replace(/(^|\s)(#[a-z\d-]+)/ig, "$1<span class='hashtag'>$2</span>");
        }
    },
    metaInfo() {
        return {
            meta: [
                {'property': 'og:url', 'content': 'https://orepormim.com.br/pedido/' + this.pray_id},
                {'property': 'og:title', 'content': 'OrePorMim - ' + this.pray.username},
                {'property': 'og:type', 'content': 'article'},
                {'property': 'og:description', 'content': this.pray.message },
                {'property': 'og:image', 'content': 'https://orepormim.com.br/img/logo_og.png'},
                {'property': 'og:image:width', 'content': '1200'},
                {'property': 'og:image:height', 'content': '630'},
                {'property': 'fb:app_id', 'content': '492862741151697'},

                {'property': 'twitter:card', 'content': 'summary_large_image'},
                {'property': 'twitter:site', 'content': '@OrePorMim'},
                {'property': 'twitter:title', 'content': 'OrePorMim - ' + this.pray.username},
                {'property': 'twitter:description', 'content': this.pray.message },
                {'property': 'twitter:image', 'content': 'https://orepormim.com.br/img/logo_og.png'},
            ]
        }
    }
}
</script>

<style lang="scss">
.achieved {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #fff;
    background-color: #388E3C;
    border-radius: 24px;
    padding: 0px 0px;
    margin: 10px 0;
}

img.icon {
    width: 32px;
    padding-right: 10px;
}

img.icon_prayers {
    width: 32px;
    padding-left: 10px;
    margin-top: 7px;
    float: right;
}

.pray_container {
    width: 100%;
    position: relative;
    text-align: center;
    padding-bottom: 40px;
}

.owner_avatar_holder {
    position: relative;
    overflow: hidden;
    margin-top: -60px;
}

.arrow {
    position: relative;
}

img.iarrow {
    width: 40px;
    position: absolute;
    z-index: 20;
    bottom: -3px;
    margin-left: -20px;
}

img.owner_avatar {
    border-radius: 50%;
    border: 6px solid white;
    width: 160px;
}

.pray_card {
    width: 350px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 11px 2px rgba(0,0,0,0.2);
    margin-top: -35px;
}

.pray_prays {
    text-align: left;
    font-size: 14px;
    padding: 15px;
}

.pray_message {
    font-family: 'Quicksand', sans-serif !important;
    background-color: #f5f5f5;
    text-align: left;
    font-size: 23px;
    line-height: 29px;
    padding: 15px;
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.15);
    z-index: 2;
    position: relative;
}

.pray_owner {
    text-align: right;
    font-weight: 700;
    font-size: 16px;
}

.pray_prayers {
    background-color: $color_realyLightBlue;
    text-align: left;
    padding: 5px 10px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.prayer {
    font-size: 14px;
    padding: 6px 0;
    border-bottom: 1px solid rgb(206, 221, 255);
}

.prayer:last-child {
    border: 0;
}

img.prayer_avatar {
    border-radius: 50%;
    border: 3px solid white;
    width: 40px;
    margin-right: 5px;
}

.watermark {
    position: absolute;
    right: 20px;
    top: 10px;
    text-align: right;
}

img.logo {
    width: 200px;
    padding-bottom: 5px;
}

img.logo-mobile {
    display: none;
    width: 210px;
    padding-bottom: 5px;
    margin-top: -120px;
}

img.googleplay { 
    width: 170px;
    margin-right: -10px;
}
</style>